import axios from "axios";
// Reemplazo de constantes locales con apiConstants desde constants.ts
import { apiConstants } from "@configs/constants";
import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';

import { store } from '@redux/storeConfig/store';
import configureInterceptors from 'utility/http/interceptors/configure-interceptors';

// Interfaces
export interface StartStreamParams {
  imei: string;
  channel: number;
  videoIP?: string;
  videoTCPPort?: string;
  videoUDPPort?: number;
}

export interface StopStreamParams {
  imei: string;
  channel: number;
}

export interface StreamStatus {
  isActive: boolean;
  startTime?: string;
  resolution?: string;
  bitrate?: number;
  error?: string;
}
export interface VideoStreamResponse {
  success: boolean;
  message?: string;
}

// Constantes - Usando el IoTHub controller
const VIDEO_API_URL = `${apiConstants.API_URL}/iothub/streaming`;

// Funciones de servicio
export const startVideoStream = async (params: StartStreamParams, configActions?: ConfigActions) : Promise<VideoStreamResponse> => {
  const {
    imei,
    channel,
    videoIP = "gps1.webtrack.online",
    videoTCPPort = "10002",
    videoUDPPort = 0,
  } = params;

  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'units.unit',
    action: 'Custom',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);

  try {
    const response = await httpWebtrack.post(`${VIDEO_API_URL}/start`, {
      imei,
      channel: String(channel),
      videoIP,
      videoTCPPort,
      videoUDPPort,
    });
    return {
      success: response.success === true,
      message: response.message,
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error starting video stream",
    };
  }
};

export const stopVideoStream = async (
  params: StopStreamParams, configActions?: ConfigActions
): Promise<VideoStreamResponse> => {
  const { imei, channel } = params;

  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'units.unit',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);

  try {
    const response = await httpWebtrack.post(`${VIDEO_API_URL}/stop`, {
      imei,
      channel,
    }
  );

    return {
      success: response.success === true,
      message: response.message,
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error stopping video stream",
    };
  }
};

export const generateStreamUrl = (channel: number, imei: string): string => {
  return `${apiConstants.STREAMING_SERVER_URL}:8890/${channel}/${imei}/hls.m3u8`;
};

export const getAvailableChannels = async (imei: string, configActions?: ConfigActions): Promise<number[]> => {
  try {
    const httpWebtrack = new HttpWebtrack();
    configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
    httpWebtrack.setConfigMessage({
      object: 'units.unit',
      action: 'Get',
      genderType: 'PluralFemale'
    });
    httpWebtrack.setConfigActions(configActions);
    const response = await httpWebtrack.get(`${VIDEO_API_URL}/channels/${imei}`) as { channels: number[] };
    return response.channels;
  } catch (error) {
    console.error("Error fetching available channels:", error);
    return [1, 2, 3, 4, 5]; // Fallback a canales por defecto
  }
};

export const getStreamStatus = async (
  imei: string,
  channel: number
): Promise<StreamStatus> => {
  try {
    const response = await axios.get(
      `${VIDEO_API_URL}/status/${imei}/${channel}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching stream status:", error);
    return {
      isActive: false,
      error: "Failed to fetch stream status"
    };
  }
};
